import React from 'react';
import { Checkbox } from 'antd';
import { SOSSimpleDropDownContainer } from './styles/dropdown.styles';
import PropTypes, { object } from 'prop-types';

export const SOSCheckBoxes = ({ handleChange, options, defaultValue }) => {
  return (
    <SOSSimpleDropDownContainer>
      <Checkbox.Group
        options={options}
        onChange={handleChange}
        defaultValue={defaultValue || []}
      />
    </SOSSimpleDropDownContainer>
  );
};

SOSCheckBoxes.propTypes = {
  options: PropTypes.arrayOf(object),
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.array,
};
